<form
  dxc-form
  class="mt-5 d-flex flex-wrap eligibility-form"
  [formGroup]="eligform"
  #form="ngForm"
  (ngSubmit)="onEligibilityFormSubmit()"
>
  <!-- left form section -->
  <div class="eligbility-form-left col-12 col-lg-6 pe-0 pe-lg-5 border-end">
    <!-- Appointment -->
    <h5 dxc-typography dxcWeight="semibold">APPOINTMENT INFORMATION</h5>
    <div class="d-flex flex-wrap">
      <dxc-form-item class="mt-4 mt-lg-2 col-12 col-md-6 pe-1 pe-lg-3">
        <dxc-form-label>Appointment Date <span class="text-danger">*</span></dxc-form-label>
        <dxc-form-control>
          <dxc-datepicker
            formControlName="appointmentDate"
            dxcSize="lg"
            class="w-100"
            [dxcShowTodayBtn]="false"
            [dxcShowNavigateBtn]="false"
            dxcSuffixIcon
            [dxcMinDate]="today"
          ></dxc-datepicker>
        </dxc-form-control>
        <ng-container *ngIf="form.submitted || eligform.controls['appointmentDate']?.dirty">
          <div *dxcHasError="'required'" dxc-form-error>Appointment Date is required</div>
          <div *dxcHasError="'minDate'" dxc-form-error>Invalid Appointment Date</div>
        </ng-container>
      </dxc-form-item>

      <dxc-form-item class="mt-4 mt-lg-2 col-12 col-md-6 ps-1 ps-lg-4">
        <dxc-form-label>Appointment Time <span class="text-danger">*</span></dxc-form-label>
        <dxc-form-control>
          <dxc-timepicker formControlName="appointmentTime"></dxc-timepicker>
        </dxc-form-control>
        <ng-container *ngIf="form.submitted || eligform.controls['appointmentTime']?.dirty">
          <div *dxcHasError="'required'" dxc-form-error>Appointment Time is required</div>
        </ng-container>
      </dxc-form-item>

      <dxc-form-item class="mt-4 col-12">
        <dxc-form-label>Procedure Codes</dxc-form-label>
        <dxc-form-control>
          <dxc-multi-select
            dxcPlaceholder="Select Procedure Codes"
            [dxcOptions]="procedureCodeOptions"
            formControlName="procedureCodes"
          />
        </dxc-form-control>
      </dxc-form-item>
    </div>

    <!-- Provider -->
    <div class="d-flex align-items-center justify-content-between mt-5">
      <h5 dxc-typography dxcWeight="semibold" class="my-0">PROVIDER INFORMATION</h5>
      <button
        dxc-button
        type="button"
        dxcVariant="outline"
        class="p-2"
        style="font-size: 0.8rem !important"
        (click)="toggleProviderUIType()"
      >
        {{ form.value['provideUIType'] === 'SELECT' ? 'New Provider' : 'Existing Provider' }}
      </button>
    </div>

    <ng-container *ngIf="form.value['provideUIType'] === 'SELECT'">
      <div class="d-flex flex-wrap">
        <dxc-form-item class="mt-4 col-6 col-md-6 pe-1 pe-lg-3">
          <dxc-form-label>Select Provider <span class="text-danger">*</span></dxc-form-label>
          <dxc-form-control>
            <dxc-dropdown
              formControlName="provider"
              class="d-block overflow-hidden"
              [dxcOptions]="_providersOptions"
              (dxcSelectedChange)="getTaxId($event)"
              >Select Provider</dxc-dropdown
            >
          </dxc-form-control>
          <ng-container *ngIf="form.submitted || eligform.controls['provider']?.dirty">
            <div *dxcHasError="'required'" dxc-form-error>Provider is required</div>
          </ng-container>
        </dxc-form-item>

        <dxc-form-item class="mt-4 col-6 col-md-6 pe-1 pe-lg-8">
          <dxc-form-label dxc-typography>Tax ID</dxc-form-label>
          <dxc-form-control>
            <input
              [readOnly]="true"
              disabled
              dxc-input
              dxcSize="lg"
              type="text"
              placeholder="Tax ID"
              [(ngModel)]="selectedProviderTaxId"
              [ngModelOptions]="{ standalone: true }"
            />
          </dxc-form-control>
        </dxc-form-item>
      </div>
    </ng-container>

    <ng-container *ngIf="form.value['provideUIType'] === 'ENTER'">
      <div class="d-flex flex-wrap">
        <dxc-form-item class="mt-4 col-6 col-md-6 pe-1 pe-lg-3">
          <dxc-form-label dxc-typography
            >First Name <span class="text-danger">*</span></dxc-form-label
          >
          <dxc-form-control>
            <input
              dxc-input
              type="text"
              formControlName="providerFirstName"
              placeholder="First Name"
              maxlength="24"
            />
          </dxc-form-control>
          <ng-container *ngIf="form.submitted || eligform.controls['providerFirstName']?.dirty">
            <div *dxcHasError="'required'" dxc-form-error>First Name is required</div>
          </ng-container>
        </dxc-form-item>

        <dxc-form-item class="mt-4 col-6 col-md-6 pe-1 pe-lg-8">
          <dxc-form-label dxc-typography
            >Last Name <span class="text-danger">*</span></dxc-form-label
          >
          <dxc-form-control>
            <input
              dxc-input
              dxcSize="lg"
              type="text"
              formControlName="providerLastName"
              placeholder="Last Name"
              maxlength="24"
            />
          </dxc-form-control>
          <ng-container *ngIf="form.submitted || eligform.controls['providerLastName']?.dirty">
            <div *dxcHasError="'required'" dxc-form-error>Last Name is required</div>
          </ng-container>
        </dxc-form-item>

        <dxc-form-item class="mt-4 col-6 col-md-6 pe-1 pe-lg-3">
          <dxc-form-label dxc-typography
            >National Provider Identifier <span class="text-danger">*</span></dxc-form-label
          >
          <dxc-form-control>
            <input
              dxc-input
              dxcSize="lg"
              type="text"
              formControlName="npi"
              placeholder="National Provider Identifier"
              maxlength="10"
            />
          </dxc-form-control>
          <ng-container *ngIf="form.submitted || eligform.controls['npi']?.dirty">
            <div *dxcHasError="'required'" dxc-form-error>NPI is required</div>
            <div *dxcHasError="'npi'" dxc-form-error>Invalid NPI</div>
          </ng-container>
        </dxc-form-item>

        <dxc-form-item class="mt-4 col-6 col-md-6 pe-1 pe-lg-8">
          <dxc-form-label dxc-typography>Tax ID</dxc-form-label>
          <dxc-form-control>
            <input
              dxc-input
              dxcSize="lg"
              type="text"
              formControlName="taxId"
              placeholder="Tax ID"
              maxlength="9"
            />
          </dxc-form-control>
          <ng-container *ngIf="form.submitted || eligform.controls['taxId']?.dirty">
            <div *dxcHasError="'required'" dxc-form-error>Tax ID is required</div>
            <div *dxcHasError="'taxId'" dxc-form-error>Invalid Tax ID</div>
          </ng-container>
        </dxc-form-item>
      </div>
    </ng-container>

    <!-- Patient -->
    <h5 dxc-typography dxcWeight="semibold" class="mt-5">PATIENT INFORMATION</h5>
    <div class="d-flex flex-wrap">
      <dxc-form-item class="mt-4 mt-md-2 col-12 col-md-6 pe-1 pe-lg-3">
        <dxc-form-label>First Name <span class="text-danger">*</span></dxc-form-label>
        <dxc-form-control>
          <input
            dxc-input
            formControlName="firstName"
            type="text"
            placeholder="First Name"
            dxcSize="lg"
            autocomplete="new-password"
          />
        </dxc-form-control>
        <ng-container *ngIf="form.submitted || eligform.controls['firstName']?.dirty">
          <div *dxcHasError="'required'" dxc-form-error>First Name is required</div>
        </ng-container>
      </dxc-form-item>

      <dxc-form-item class="mt-4 mt-md-2 mt-md-0 col-12 col-md-6 ps-0 ps-lg-3">
        <dxc-form-label>Last Name <span class="text-danger">*</span></dxc-form-label>
        <dxc-form-control>
          <input
            dxc-input
            formControlName="lastName"
            type="text"
            placeholder="Last Name"
            dxcSize="lg"
            autocomplete="new-password"
          />
        </dxc-form-control>
        <ng-container *ngIf="form.submitted || eligform.controls['lastName']?.dirty">
          <div *dxcHasError="'required'" dxc-form-error>Last Name is required</div>
        </ng-container>
      </dxc-form-item>

      <dxc-form-item class="mt-4 col-12 col-md-6 pe-1 pe-lg-3">
        <dxc-form-label>Date of Birth <span class="text-danger">*</span></dxc-form-label>
        <dxc-form-control>
          <dxc-datepicker
            formControlName="dateOfBirth"
            dxcSize="lg"
            class="w-100 d-block"
            [dxcShowTodayBtn]="false"
            [dxcShowNavigateBtn]="false"
            [dxcMinDate]="minDate"
            [dxcMaxDate]="today"
            dxcSuffixIcon
            dxcInputAutocomplete="off"
          ></dxc-datepicker>
        </dxc-form-control>
        <ng-container *ngIf="form.submitted || eligform.controls['dateOfBirth']?.dirty">
          <div *dxcHasError="'required'" dxc-form-error>Date of Birth is required</div>
        </ng-container>
      </dxc-form-item>

      <dxc-form-item class="mt-4 col-12 col-md-6 ps-0 ps-lg-3">
        <dxc-form-label> Zip Code <span class="text-danger">*</span></dxc-form-label>
        <dxc-form-control>
          <input
            dxc-input
            formControlName="zipCode"
            type="text"
            placeholder="Zip Code"
            dxcSize="lg"
            maxlength="10"
            autocomplete="new-password"
          />
        </dxc-form-control>
        <ng-container *ngIf="form.submitted || eligform.controls['zipCode']?.dirty">
          <div *dxcHasError="'required'" dxc-form-error>Zip Code is required</div>
          <div *dxcHasError="'pattern'" dxc-form-error>
            Please enter a valid ZIP Code (e.g., 12345 or 12345-6789).
          </div>
        </ng-container>
      </dxc-form-item>

      <dxc-form-item class="mt-4 col-12 col-md-6 pe-1 pe-lg-3">
        <dxc-form-label> Member ID <span class="text-danger">*</span></dxc-form-label>
        <dxc-form-control>
          <input
            dxc-input
            formControlName="memberId"
            type="text"
            placeholder="Member ID"
            dxcSize="lg"
            autocomplete="off"
          />
        </dxc-form-control>
        <ng-container *ngIf="form.submitted || eligform.controls['memberId']?.dirty">
          <div *dxcHasError="'required'" dxc-form-error>Member ID is required</div>
          <div *dxcHasError="'minlength'" dxc-form-error>
            Member ID needs be more than 3 character
          </div>
        </ng-container>
      </dxc-form-item>

      <dxc-form-item class="mt-4 col-12 col-md-6 ps-0 ps-lg-3">
        <dxc-form-label>Group Number</dxc-form-label>
        <dxc-form-control>
          <input
            dxc-input
            formControlName="groupId"
            type="text"
            placeholder="Group Number"
            dxcSize="lg"
            autocomplete="off"
          />
        </dxc-form-control>
        <ng-container *ngIf="form.submitted || eligform.controls['groupId']?.dirty">
          <div *dxcHasError="'required'" dxc-form-error>Group Number is required</div>
          <div *dxcHasError="'minlength'" dxc-form-error>
            Group Number needs be more than 3 character
          </div>
        </ng-container>
      </dxc-form-item>
    </div>
  </div>

  <!-- insurance form -->
  <div class="eligbility-form-right mt-5 mt-lg-0 col-12 col-lg-6 ps-0 ps-lg-5">
    <!-- Insurance -->
    <h5 dxc-typography dxcWeight="semibold">INSURANCE INFORMATION</h5>
    <dxc-form-item class="mt-2">
      <dxc-form-label> Select Insurance Payer <span class="text-danger">*</span></dxc-form-label>
      <dxc-single-select
        class="d-block"
        dxcPlaceholder="Select Payer"
        [dxcOptions]="_payersOptions"
        formControlName="insurancePayer"
        >Select Payer</dxc-single-select
      >
      <ng-container *ngIf="form.submitted || eligform.controls['insurancePayer']?.dirty">
        <div *dxcHasError="'required'" dxc-form-error>Payer is required</div>
      </ng-container>
    </dxc-form-item>

    <!-- Subscriber -->
    <div class="d-flex align-items-center justify-content-between mt-5">
      <h5 dxc-typography dxcWeight="semibold" class="my-0">SUBSCRIBER INFORMATION</h5>
      <button
        dxc-button
        type="button"
        dxcVariant="outline"
        class="p-2"
        style="font-size: 0.8rem !important"
        (click)="onSubscriberSameAsPatient.emit()"
      >
        Same as Patient
      </button>
    </div>

    <div class="d-flex flex-wrap mt-4 mt-md-2">
      <dxc-form-item class="col-12 col-md-6 pe-1 pe-lg-3">
        <dxc-form-label>First Name <span class="text-danger">*</span></dxc-form-label>
        <dxc-form-control>
          <input
            dxc-input
            formControlName="subscriberFirstName"
            type="text"
            placeholder="First Name"
            dxcSize="lg"
            autocomplete="new-password"
          />
        </dxc-form-control>
        <ng-container *ngIf="form.submitted || eligform.controls['subscriberFirstName']?.dirty">
          <div *dxcHasError="'required'" dxc-form-error>First Name is required</div>
        </ng-container>
      </dxc-form-item>

      <dxc-form-item class="mt-2 mt-md-0 col-12 col-md-6 ps-0 ps-lg-3">
        <dxc-form-label>Last Name <span class="text-danger">*</span></dxc-form-label>
        <dxc-form-control>
          <input
            dxc-input
            formControlName="subscriberLastName"
            type="text"
            placeholder="Last Name"
            dxcSize="lg"
            autocomplete="new-password"
          />
        </dxc-form-control>
        <ng-container *ngIf="form.submitted || eligform.controls['subscriberLastName']?.dirty">
          <div *dxcHasError="'required'" dxc-form-error>Last Name is required</div>
        </ng-container>
      </dxc-form-item>

      <dxc-form-item class="mt-4 col-12 col-md-6 pe-1 pe-lg-3">
        <dxc-form-label>Date of Birth <span class="text-danger">*</span></dxc-form-label>
        <dxc-form-control>
          <dxc-datepicker
            formControlName="subscriberDateOfBirth"
            dxcSize="lg"
            class="w-100 d-block"
            [dxcShowTodayBtn]="false"
            [dxcShowNavigateBtn]="false"
            [dxcMinDate]="minDate"
            [dxcMaxDate]="today"
            dxcSuffixIcon
            dxcInputAutocomplete="off"
          ></dxc-datepicker>
        </dxc-form-control>
        <ng-container *ngIf="form.submitted || eligform.controls['subscriberDateOfBirth']?.dirty">
          <div *dxcHasError="'required'" dxc-form-error>Date of Birth is required</div>
        </ng-container>
      </dxc-form-item>

      <dxc-form-item class="mt-4 col-12 col-md-6 ps-1 ps-lg-3">
        <dxc-form-label>Zip Code <span class="text-danger">*</span></dxc-form-label>
        <dxc-form-control>
          <input
            dxc-input
            formControlName="subscriberZipCode"
            type="text"
            placeholder="Zip Code"
            maxlength="10"
            autocomplete="new-password"
          />
        </dxc-form-control>
        <ng-container *ngIf="form.submitted || eligform.controls['subscriberZipCode']?.dirty">
          <div *dxcHasError="'required'" dxc-form-error>Zip Code is required</div>
          <div *dxcHasError="'pattern'" dxc-form-error>
            Please enter a valid ZIP Code (e.g., 12345 or 12345-6789).
          </div>
        </ng-container>
      </dxc-form-item>

      <dxc-form-item class="mt-4 col-12 col-md-6 pe-1 pe-lg-3">
        <dxc-form-label>Member ID <span class="text-danger">*</span></dxc-form-label>
        <dxc-form-control>
          <input
            dxc-input
            formControlName="subscriberMemberId"
            type="text"
            placeholder="Member ID"
            dxcSize="lg"
            autocomplete="off"
          />
        </dxc-form-control>
        <ng-container *ngIf="form.submitted || eligform.controls['subscriberMemberId']?.dirty">
          <div *dxcHasError="'required'" dxc-form-error>Member ID is required</div>
          <div *dxcHasError="'minlength'" dxc-form-error>
            Member ID needs be more than 3 character
          </div>
        </ng-container>
      </dxc-form-item>

      <dxc-form-item class="mt-4 col-12 col-md-6 ps-1 ps-lg-3">
        <dxc-form-label>Group Number</dxc-form-label>
        <dxc-form-control>
          <input
            dxc-input
            formControlName="subscriberGroupId"
            type="text"
            placeholder="Group Number"
            dxcSize="lg"
            autocomplete="off"
          />
        </dxc-form-control>
        <ng-container *ngIf="form.submitted || eligform.controls['subscriberGroupId']?.dirty">
          <div *dxcHasError="'required'" dxc-form-error>Group Number is required</div>
          <div *dxcHasError="'minlength'" dxc-form-error>
            Group Number needs be more than 3 character
          </div>
        </ng-container>
      </dxc-form-item>

      <dxc-form-item class="mt-4">
        <dxc-form-label
          >Relationship To Subscriber <span class="text-danger">*</span></dxc-form-label
        >
        <dxc-form-control>
          <div class="mx-auto">
            <div class="form-check mt-2" *ngFor="let relationship of relationshipOptions">
              <input
                type="radio"
                id="{{ relationship.name }}-radio'"
                formControlName="relationshipToSubscriber"
                class="form-check-input"
                [value]="relationship.value"
              />
              <label class="form-check-label" for="{{ relationship.name }}-radio'">{{
                relationship.name
              }}</label>
            </div>
          </div>
        </dxc-form-control>
        <ng-container
          *ngIf="form.submitted || eligform.controls['relationshipToSubscriber']?.dirty"
        >
          <div *dxcHasError="'required'" dxc-form-error>Subscriber Relationship is required</div>
        </ng-container>
      </dxc-form-item>

      <dxc-form-item class="mt-4 col-12">
        <dxc-form-label>TAGS</dxc-form-label>
        <dxc-form-control>
          <dxc-multi-select
            dxcPlaceholder="Select Tags"
            dxcAllowAddNewOption="true"
            [dxcOptions]="tagsOptions"
            formControlName="tags"
          />
        </dxc-form-control>
      </dxc-form-item>
    </div>
  </div>

  <div class="mt-5 col-12 d-flex justify-content-center align-items-center">
    <button
      dxc-button
      type="button"
      dxcVariant="outline"
      [disabled]="submitLoading"
      class="me-2 me-md-3"
      *ngIf="!this.isEditAppointment"
      (click)="clearForm()"
    >
      CLEAR
    </button>
    <button dxc-button type="submit" [dxcLoading]="submitLoading" [disabled]="submitLoading">
      {{ isEditAppointment ? 'EDIT APPOINTMENT' : 'CHECK ELIGIBILITY' }}
    </button>
  </div>
</form>
